// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"552e1bc5","239":"4a41bfb1","441":"b4ac1c2c","578":"1316f6a9","622":"909ece56","904":"a2e0ecd1","977":"2899dd08"}[chunkId] + ".chunk.js";
};